<app-filters-checkbox-item
    title="{{ 'filters.skillsInterests.myInterests' | translate }}"
    [option]="interestsFilterItem"
    (selectionChange)="onInterestsSelectionChanged()"
></app-filters-checkbox-item>
